import type { HtmlHTMLAttributes } from "react";

import { cn } from "@/lib/helpers/cn";

export function Main2({ className, ...mainProps }: HtmlHTMLAttributes<HTMLDivElement>) {
  return (
    <main
      className={cn(
        "tw:flex tw:flex-col tw:gap-5",
        "tw:max-lg:mx-8 tw:lg:mx-auto",
        "tw:py-6",
        "tw:lg:w-full tw:lg:max-w-(--content-max-width-lg)! tw:xl:max-w-(--content-max-width-xl)!",
        className,
      )}
      {...mainProps}
    />
  );
}
